import { jsx as r } from "react/jsx-runtime";
const t = ({ size: H }) => {
  switch (H) {
    case "sm":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M7.49833 8.49837H3.665V7.49837H7.49833V3.66504H8.49833V7.49837H12.3317V8.49837H8.49833V12.3317H7.49833V8.49837Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M11.25 12.75H5.5V11.25H11.25V5.5H12.75V11.25H18.5V12.75H12.75V18.5H11.25V12.75Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M9.37333 10.6266H4.58167V9.37663H9.37333V4.58496H10.6233V9.37663H15.415V10.6266H10.6233V15.4183H9.37333V10.6266Z",
          fill: "currentColor"
        }
      );
  }
}, e = ({ size: H }) => {
  switch (H) {
    case "sm":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M7.24383 8.76045H3.2V7.24378H7.24383V3.19995H8.7605V7.24378H12.8043V8.76045H8.7605V12.8043H7.24383V8.76045Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M10.8605 13.1357H4.79475V10.8607H10.8605V4.79492H13.1355V10.8607H19.2013V13.1357H13.1355V19.2014H10.8605V13.1357Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M9.05412 10.9457H3.99933V9.04991H9.05412V3.99512H10.95V9.04991H16.0047V10.9457H10.95V16.0005H9.05412V10.9457Z",
          fill: "currentColor"
        }
      );
  }
}, o = ({
  size: H = "md",
  weight: V = "default"
}) => {
  switch (V) {
    case "bold":
      return /* @__PURE__ */ r(e, { size: H });
    case "book":
    case "default":
      return /* @__PURE__ */ r(t, { size: H });
  }
};
export {
  o as default
};
//# sourceMappingURL=DIconAdd.js.map
